"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var WILLINGNESS_TRUST_LET_GO_ADDICTED_SELF = "WILLINGNESS_TRUST_LET_GO_ADDICTED_SELF";
var questions = [{
  prompt: "Decisions during the morning period of the day:",
  type: "radio",
  options: ["I did what I wanted", "I was willing to hand it over and trust"],
  batteryId: WILLINGNESS_TRUST_LET_GO_ADDICTED_SELF,
  meta: {
    summaryTitle: "Decisions during the morning period of the day"
  }
}, {
  prompt: "Decisions during the middle of the day:",
  type: "radio",
  options: ["I did what I wanted", "I was willing to hand it over and trust"],
  batteryId: WILLINGNESS_TRUST_LET_GO_ADDICTED_SELF,
  meta: {
    summaryTitle: "Decisions during the middle of the day"
  }
}, {
  prompt: "Decisions during the afternoon:",
  type: "radio",
  options: ["I did what I wanted", "I was willing to hand it over and trust"],
  batteryId: WILLINGNESS_TRUST_LET_GO_ADDICTED_SELF,
  meta: {
    summaryTitle: "Decisions during the afternoon"
  }
}, {
  prompt: "Decisions during the evening and night:",
  type: "radio",
  options: ["I did what I wanted", "I was willing to hand it over and trust"],
  batteryId: WILLINGNESS_TRUST_LET_GO_ADDICTED_SELF,
  meta: {
    summaryTitle: "Decisions during the evening and night"
  }
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    var _answers$question$bat;

    if (!question.hideFromSummary && (_answers$question$bat = answers[question.batteryId][index]) !== null && _answers$question$bat !== void 0 && _answers$question$bat.toString()) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;